import React from 'react';
import {Flex, Alert, AlertIcon, AlertTitle} from '@tempo/core';

const AnalyticError = () => {
	return (
		<Flex
			as="section"
			flexDirection="column"
			bg="background.neutral.secondary.default"
			borderRadius="lg"
			p={{base: 'spacing.l', md: 'spacing.xl'}}
			width="100%"
			justifyContent="center"
			alignItems="center"
			data-testid="analytic-error"
		>
			<Alert status="error" borderRadius="md" width="100%" maxWidth="sm">
				<AlertIcon />
				{/*fixme translate*/}
				<AlertTitle>Failed to load data for this chart</AlertTitle>
			</Alert>
		</Flex>
	);
};

export default AnalyticError;
